// TODO NEEDS TO BE REFACTORED. SEPARATED WITH INDEPENDENT FILES

import React, { useState, useContext, useRef } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import Checkbox from '../common/Checkbox';
import FilterDispatch from '../../contexts/filterDispatch';
import filterActions from '../../actions/filter.actions';

import { changeUser, archive } from './ClientTableHandlers';
import style from './CellRenders.module.css';

export function Archived({ cell, history }) {
  const [checkbox, setCheckbox] = useState(cell.value);
  const dispatch = useContext(FilterDispatch);

  const handleArchive = e => {
    const queryParameters = history.location.search;
    const params = new URLSearchParams(queryParameters);
    const op = params.get('op');

    setCheckbox(!checkbox);

    archive(e.target.checked, cell.row.Id)
      .then(() => {
        params.set('op', op === '0' ? '1' : '0');
        history.push(`${history.location.pathname}?${params.toString()}`);

        dispatch({
          type: filterActions.FILTER_CHANGED_SUCCESS,
        });

        toast.success(
          !checkbox ? 'Client was archived.' : 'Client was unarchived.',
          {
            position: toast.POSITION.TOP_RIGHT,
          },
        );
      })
      .catch(() => {
        setCheckbox(checkbox);
        toast.error('Something went wrong. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <Checkbox
      type="checkbox"
      className="cb-is-archived"
      checked={checkbox}
      onChange={handleArchive}
    />
  );
}

export function BusinessName(props) {
  const { cell } = props;
  const { Id, IsNotPreSubmittedProspect } = cell.original;
  if (IsNotPreSubmittedProspect) {
    return (
      <a href={`/clients/${Id}`} title={cell.value}>
        {cell.value}
      </a>
    );
  }

  const link = `/start/${Id}`;
  return (
    <a target="_top" href={link} title={cell.value}>
      {cell.value}
    </a>
  );
}

export function getUserName(user) {
  return `${user.FirstName || ''} ${user.LastName || ''}`.trim();
}

export function getSelectUserName(id, users) {
  const selectedUser = users.filter(u => u.Id === id)[0];
  return selectedUser ? getUserName(selectedUser) : '';
}

export function AgencyUser(props) {
  const {
    clientId,
    currentUser,
    users,
    producer,
    csrAgencyId,
    csrId,
    producerAgencyId,
    producerId,
    width,
  } = props;

  const [options, setOptions] = useState(
    currentUser && currentUser[0] !== undefined ? currentUser : [],
  );
  const [value, setValue] = useState(undefined);
  const [topPos, setTopPos] = useState(undefined);

  const selectStyles = {
    menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    control: base => ({
      ...base,
      margin: 8,
      height: '44px',
      boxShadow: 'inset 0 2px 2px 0 rgba(132, 130, 156, 0.2)',
      borderStyle: 'solid',
      borderWidth: '1px',
      '&:hover': {
        borderColor: '#80bdff',
      },
    }),
  };

  const Menu = p => {
    const shadow = 'hsla(218, 50%, 10%, 0.1)';
    return (
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: 4,
          boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
          position: 'fixed',
          zIndex: 2,
          width: width - 20,
          marginTop: 8,
          top: topPos || 'auto',
        }}
        {...p}
      />
    );
  };
  const Blanket = p => (
    <div
      style={{
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
        position: 'fixed',
        zIndex: 1,
      }}
      {...p}
    />
  );

  const Dropdown = ({ children, isOpen, target, onClose, title }) => (
    <div style={{ position: 'relative' }} title={title}>
      {target}
      {isOpen ? <Menu>{children}</Menu> : null}
      {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
  );

  const Svg = p => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      focusable="false"
      role="presentation"
      {...p}
    />
  );
  const DropdownIndicator = () => (
    <div style={{ color: '#cccccc', height: 24, width: 32 }}>
      <Svg>
        <path
          d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </Svg>
    </div>
  );
  const ChevronDown = () => (
    <Svg
      style={{
        minWidth: 20,
        minHeight: 20,
        marginLeft: 8,
        color: 'rgb(204, 204, 204)',
      }}
    >
      <path
        d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        fill="currentColor"
      />
    </Svg>
  );

  const [isOpen, setIsOpen] = useState(false);
  const btnRef = useRef(null);

  const toggleOpen = () => {
    setTopPos(
      btnRef.current.getBoundingClientRect().top + btnRef.current.clientHeight,
    );
    setOptions(users);
    setIsOpen(!isOpen);
  };

  const handleReassign = user => {
    changeUser(
      clientId,
      producer,
      user.value,
      csrAgencyId,
      csrId,
      producerAgencyId,
      producerId,
    )
      .then(() => {
        toast.success('Client was reassigned.', {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch(() => {
        toast.error('Something went wrong. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const onSelectChange = v => {
    toggleOpen();
    handleReassign(v);
    setValue(v);
  };

  return (
    <Dropdown
      title={
        value
          ? value.label
          : undefined || (currentUser[0] ? currentUser[0].label : '')
      }
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <button
          type="button"
          onClick={toggleOpen}
          ref={btnRef}
          style={{
            width: '100%',
            alignItems: 'center',
            backgroundColor: 'rgb(255, 255, 255)',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            minHeight: 38,
            boxSizing: 'border-box',
            borderColor: 'rgb(204, 204, 204)',
            borderRadius: 4,
            borderStyle: 'solid',
            borderWidth: 1,
            transition: 'all 100ms ease 0s',
            outline: ' 0px !important',
          }}
        >
          <span
            style={{
              padding: '2px 10px',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flexGrow: 2,
              overflow: 'hidden',
              textAlign: 'start',
            }}
          >
            {(value && value.label) ||
              (currentUser[0] ? currentUser[0].label : 'Select...')}
          </span>
          <div
            style={{
              alignSelf: 'stretch',
              backgroundColor: 'rgb(204, 204, 204)',
              marginBottom: 2,
              marginTop: 2,
              width: 1,
              boxSizing: 'border-box',
            }}
          />
          <ChevronDown />
        </button>
      }
    >
      <Select
        autoFocus
        backspaceRemovesValue={false}
        components={{ DropdownIndicator, IndicatorSeparator: null }}
        controlShouldRenderValue={false}
        hideSelecteddwOptions={false}
        isClearable={false}
        menuIsOpen
        defaultValue={currentUser[0]}
        onChange={onSelectChange}
        options={options}
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
}

const tableButtonStyle = { width: 90, marginRight: 0, marginLeft: 'auto' };

function EndTableButton(clientData) {
  if (clientData.IsNotPreSubmittedProspect)
    return (
      <a
        href={`/clients/${clientData.Id}`}
        className={`btn btn-primary ${style.noShadow}`}
        style={tableButtonStyle}
      >
        View Details
      </a>
    );

  return (
    <a
      target="_top"
      href={`/start/${clientData.Id}`}
      className={`btn btn-primary finish-app-btn  ${style.noShadow}`}
      style={tableButtonStyle}
    >
      Finish App
    </a>
  );
}

export function ActionsButton(props) {
  const {
    Id,
    IsNotPreSubmittedProspect,
    HasInForcePolicies,
    UaClientCreatedOn,
    HasProposedQuotes,
  } = props;

  if (!HasInForcePolicies || !IsNotPreSubmittedProspect)
    return EndTableButton(props);

  return (
    <div className="dropdown" id="action-dd" style={tableButtonStyle}>
      <button
        type="button"
        className={`btn btn-default dropdown-toggle w-100 pl-0 ${style.noShadow}`}
        data-boundary="action-dd"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Actions
      </button>
      <ul className="dropdown-menu dropdown-menu-right">
        <li>
          <Link to={`/clients/${Id}`} className="btn-view-details">
            View Details
          </Link>
        </li>
        {HasProposedQuotes && (
          <li>
            <Link to={`/clients/${Id}/requests/proposal-comparison`}>
              Request Proposal Comparison
            </Link>
          </li>
        )}
        {UaClientCreatedOn && (
          <li>
            <Link to={`/start/${Id}`}>Start Renewal</Link>
          </li>
        )}
        <li>
          <Link to={`/clients/${Id}/requests/policy-document`}>
            Request Policy Document
          </Link>
        </li>
        <li>
          <Link to={`/clients/${Id}/documents`}>View Documents</Link>
        </li>
        <li>
          <Link to={`/clients/${Id}/requests/endorsement`}>
            Request Endorsement
          </Link>
        </li>
        <li>
          <Link to={`/clients/${Id}/endrosements`}>Endorsement Requests</Link>
        </li>
        <li>
          <Link to={`/clients/${Id}/requests/cancel`}>Request Cancel/ERP</Link>
        </li>
        <li>
          <Link to={`/clients/${Id}/requests/other`}>
            Other Service Requests
          </Link>
        </li>
      </ul>
    </div>
  );
}
